module.exports = __webpack_public_path__ + "img/osasuna-logo-icon.f0af5164.png";